export default __webpack_public_path__ + "static/media/stats1.9cd23f7b.png";